import React, { useEffect, useRef, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { dataService } from "../services/dataService";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import TablerLayout from "../components/layout/TablerLayout";

import FloatingLabelInput from "../components/form_elements/FloatingLabelInput";
import FloatingSelectInput from "../components/form_elements/FloatingSelectInput";
import Modal from "../components/modals/Modal";
import { IconAlertCircle, IconCheck, IconExclamationMark, IconLock } from "@tabler/icons-react";

const Adat = () => {
	const navigate = useStepNavigate();

	const { order, updateOrder } = useOrder();
	const { saveOrder, loading: orderSaveLoading } = useOrderSave();
	const [loading, setLoading] = useState(false);

	const containerRef = useRef(null);
	const [LakcimError, setLakcimError] = useState("");
	const [tajError, setTajError] = useState("");
	const [showNewPartnerModal, setShowNewPartnerModal] = useState(false);
	const [showSaveModal, setShowSaveModal] = useState({
		open: false,
		message: "",
	});

	const closeModal = () => setShowSaveModal({ open: false, message: "" });

	const [cities, setCities] = useState([]);
	const [showZipSuggestions, setShowZipSuggestions] = useState(false);
	const [showCitySuggestions, setShowCitySuggestions] = useState(false);

	const countries = [
		{ partner_country_szam: 2, partner_country_name: "Magyarország" },
		{ partner_country_szam: 3, partner_country_name: "Szlovákia" },
		{ partner_country_szam: 4, partner_country_name: "Románia" },
		{ partner_country_szam: 5, partner_country_name: "Szerbia" },
		{ partner_country_szam: 6, partner_country_name: "Horvátország" },
		{ partner_country_szam: 7, partner_country_name: "Szlovénia" },
		{ partner_country_szam: 8, partner_country_name: "Csehország" },
		{ partner_country_szam: 9, partner_country_name: "Ausztria" },
		{ partner_country_szam: 10, partner_country_name: "Németország" },
	];

	const PARTNER_TYPES = [
		{ partner_type: 2, partner_type_name: "Magánszemély" },
		{ partner_type: 3, partner_type_name: "Egyéni vállalkozás" },
		{ partner_type: 4, partner_type_name: "Társas vállalkozás" },
	];

	const [fieldsLocked, setFieldsLocked] = useState(false);
	const [wasUnlocked, setWasUnlocked] = useState(false);

	const canSubmit =
		order.partner.partner_name &&
		order.partner.partner_zip &&
		order.partner.partner_city &&
		order.partner.partner_address &&
		order.partner.partner_phone &&
		// (order.order_type === 3 || (order.partner.partner_taj && !tajError)) &&
		((order.hmeliorder?.hmeliorder_order_type === 1 && order.partner.partner_taj && !tajError) || (order.hmeliorder?.hmeliorder_order_type === 2 && order.partner.partner_birthday && order.partner.partner_birthplace) || order.hmeliorder?.hmeliorder_order_type === 3) &&
		!LakcimError;

	useEffect(() => {
		console.log("canSubmit:", canSubmit);
		if (order.partner && order.partner.partner_szam > 1) {
			if (canSubmit && !wasUnlocked) {
				console.log("Zárolás: minden kötelező mező kitöltve");
				setFieldsLocked(true);
				setWasUnlocked(false);
			}
			if (!canSubmit) {
				console.log("Nyitás: hiányzó kötelező mező");
				setFieldsLocked(false);
				setWasUnlocked(true);
			}
		} else {
			console.log("Nyitás: nincs partner vagy új partner");
			setFieldsLocked(false);
			setWasUnlocked(false);
		}
	}, [order.partner, order.partner?.partner_szam, canSubmit, wasUnlocked]);

	const handleUnlock = () => {
		setFieldsLocked(false);
		setWasUnlocked(true);
	};

	useEffect(() => {
		if (wasUnlocked) setFieldsLocked(false);
	}, [wasUnlocked]);

	useEffect(() => {
		if (order.ojote?.ojote_jogviszony === "Z" && order.ojote?.taj) {
			updateOrder({
				...order,
				partner: {
					...order.partner,
					partner_taj: order.ojote.taj,
				},
			});
		}
	}, [order.ojote?.ojote_jogviszony, order.ojote?.taj]);

	const handleInputChange = (e) => {
		const { name, value } = e.target;

		let newValue = value;
		if (name === "partner_name") {
			newValue = value.toUpperCase();
		}

		if (name === "partner_city") {
			newValue = value.toUpperCase();
		}

		if (name === "partner_country_szam") {
			updateOrder({
				...order,
				partner: {
					...order.partner,
					partner_country_szam: Number(newValue),
					partner_zip: "",
					partner_city: "",
					partner_address: "",
				},
			});
			return;
		}

		if (name === "partner_address") {
			const lakcimRegex = /^[A-Za-z0-9À-ÿ\u0150\u0151\u0170\u0171\u0160\u0161\s.,/-]*$/;
			if (!lakcimRegex.test(newValue)) {
				setLakcimError("A lakcím mező csak betűket, számokat, szóközöket és a következő karaktereket tartalmazhatja: , . / -");
			} else {
				setLakcimError("");
			}
			newValue = value.toUpperCase();
		}

		if (name === "partner_taj") {
			const tajRegex = /^\d{9}$/;
			if (!tajRegex.test(newValue)) {
				setTajError("A TAJ számnak 9 számjegyből kell állnia!");
			} else {
				setTajError("");
			}
		}

		updateOrder({
			...order,
			partner: {
				...order.partner,
				[name]: newValue,
			},
		});
	};

	const handleBackToPartnerValaszto = () => {
		navigate("/PartnerValaszto");
	};

	const handleNewPartner = () => {
		if (Number(order.partner.partner_szam) > 1) {
			setShowNewPartnerModal(true);
			return;
		}
		resetPartnerForm();
		console.log(order);
	};

	const resetPartnerForm = () => {
		updateOrder({
			...order,
			partner: {
				partner_szam: 1,
				partner_type: 2,
				partner_name: "",
				partner_taj: order.ojote?.ojote_jogviszony === "Z" && order.ojote?.taj ? order.ojote.taj : "",
				partner_country_szam: 2,
				partner_country: "",
				partner_zip: "",
				partner_city_szam: 1,
				partner_city: "",
				partner_address: "",
				partner_email: "",
				partner_phone: "",
				partner_birthday: "",
				partner_birthplace: "",
				partner_charitycare_num: "",
				partner_charity_validdate: "",
			},
		});
		setFieldsLocked(false);
		setShowNewPartnerModal(false);
	};

	useEffect(() => {
		dataService.getCities().then((response) => {
			if (response.data?.status === "ok") {
				setCities(response.data.data || []);
			}
		});
	}, []);

	const zipSuggestions =
		order.partner.partner_zip.length >= 2
			? cities
					.filter((city) => city.city_zip.startsWith(order.partner.partner_zip))
					.map((city) => ({ zip: city.city_zip, city: city.city_name }))
					.filter((v, i, arr) => arr.findIndex((x) => x.zip === v.zip && x.city === v.city) === i)
					.sort((a, b) => {
						const zipCompare = String(a.zip).localeCompare(String(b.zip), "hu", { numeric: true });
						if (zipCompare !== 0) return zipCompare;
						return String(a.city).localeCompare(String(b.city), "hu");
					})
			: [];

	const citySuggestions =
		order.partner.partner_city.length >= 2
			? cities
					.filter((city) => city.city_name.toUpperCase().startsWith(order.partner.partner_city))
					.map((city) => ({ city: city.city_name, zip: city.city_zip }))
					.filter((v, i, arr) => arr.findIndex((x) => x.city === v.city && x.zip === v.zip) === i)
					.sort((a, b) => {
						const cityCompare = String(a.city).localeCompare(String(b.city), "hu");
						if (cityCompare !== 0) return cityCompare;
						return String(a.zip).localeCompare(String(b.zip), "hu", { numeric: true });
					})
			: [];

	const getSuggestionListSize = (suggestionCount, hasPrompt) => {
		const visibleRows = suggestionCount + (hasPrompt ? 1 : 0);
		return Math.min(8, Math.max(2, visibleRows));
	};

	const handleZipInput = (e) => {
		const zip = e.target.value;
		updateOrder({
			...order,
			partner: {
				...order.partner,
				partner_zip: zip,
			},
		});
		setShowCitySuggestions(false);
		setShowZipSuggestions(true);
	};

	const handleCityInput = (e) => {
		const city = e.target.value.toUpperCase();

		updateOrder({
			...order,
			partner: {
				...order.partner,
				partner_city: city,
			},
		});
		setShowZipSuggestions(false);
		setShowCitySuggestions(true);
	};

	const handleNext = async () => {
		/*
	const selectedCountry = countries.find(
	  (c) =>
		String(c.partner_country_szam) === String(formData.partner_country_szam)
	);
	const partner_country = selectedCountry ? selectedCountry.partner_country_name : "";
	const selected_partner_type = PARTNER_TYPES.find(
	  (t) => Number(t.partner_type) === Number(formData.partner_type)
	);

	updateOrder({
	  ...order,
	  partner: {
		...order.partner,
		partner_country,
		partner_type: Number(selected_partner_type.partner_type)
	  }
	});
	*/

		try {
			setLoading(true);
			const response = await dataService.savePartner(order.partner);
			console.log("Partner mentése:", response.data);

			if (response.data?.status === "ok") {
				const savedPartner = response.data.data || {};
				const savedPartnerTaj = savedPartner.partner_taj;
				const safePartnerTaj =
					savedPartnerTaj === undefined || savedPartnerTaj === null || savedPartnerTaj === ""
						? order.partner.partner_taj
						: savedPartnerTaj;

				const updatedOrder = {
					...order,
					partner: {
						...order.partner,
						...savedPartner,
						partner_taj: safePartnerTaj,
					},
				};

				updateOrder(updatedOrder);
				const result = await saveOrder(updatedOrder);
				console.log("Rendelés mentése:", updatedOrder);
				if (result.success) {
					navigate("/ProjektValaszto");
					setLoading(false);
				} else {
					setLoading(false);
				}
			} else {
				setShowSaveModal({
					open: true,
					status: response.data.status,
					message: response.data.message,
				});
				setLoading(false);
			}
		} catch (error) {
			setShowSaveModal({
				open: true,
				status: "error",
				message: "Hiba történt a mentés során!",
			});
			setLoading(false);
		}
	};

	return (
		<TablerLayout title="Partner adatlap - Lehetősége van az adatok megadására, módosítására">
			<div ref={containerRef}>
				<div className="card-body">
					<div className="row mb-3">
						<div className="col-lg-3">
							<FloatingSelectInput
								id="partner_type"
								name="partner_type"
								label="Partner típus *"
								value={order.partner.partner_type || 2}
								onChange={handleInputChange}
								options={[
									{ value: "", label: "Válasszon..." },
									...PARTNER_TYPES.map((pt) => ({
										value: pt.partner_type,
										label: pt.partner_type_name,
									})),
								]}
								required
								disabled={fieldsLocked}
							/>
						</div>
						<div className="col-lg-9">
							<FloatingLabelInput type="text" label="Név *" id="partner_name" name="partner_name" value={order.partner.partner_name || ""} onChange={handleInputChange} error="" check_type="partner_name" required disabled={fieldsLocked} />
						</div>
					</div>
					{order.hmeliorder?.hmeliorder_order_type !== 3 && (
						<>
							<div className="row mb-3">
								<div className="col-lg-12">
									<FloatingLabelInput type="text" label="TAJ szám *" id="partner_taj" name="partner_taj" value={order.partner.partner_taj || ""} onChange={handleInputChange} error={tajError} disabled={order.ojote?.ojote_jogviszony === "Z" || fieldsLocked} />
								</div>
							</div>
						</>
					)}

					<div className="row mb-3">
						<div className="col-lg-3">
							<FloatingSelectInput
								id="partner_country_szam"
								name="partner_country_szam"
								label="Ország *"
								value={order.partner.partner_country_szam || 2}
								onChange={handleInputChange}
								options={[
									{ value: "", label: "Válasszon..." },
									...countries.map((c) => ({
										value: c.partner_country_szam,
										label: c.partner_country_name,
									})),
								]}
								required
								disabled={fieldsLocked}
							/>
						</div>
						<div className="col-lg-3">
							<FloatingLabelInput
								type="text"
								label="Irányítószám *"
								id="partner_zip"
								name="partner_zip"
								value={order.partner.partner_zip || ""}
								onChange={handleZipInput}
								autoComplete="off"
								required
								disabled={fieldsLocked}
								onFocus={() => {
									if (Number(order.partner.partner_country_szam) === 2) setShowZipSuggestions(true);
								}}
								onBlur={() => setTimeout(() => setShowZipSuggestions(false), 150)}
							/>
							{Number(order.partner.partner_country_szam) === 2 && showZipSuggestions && zipSuggestions.length > 0 && !fieldsLocked && (
								(() => {
									const zipHasPrompt = zipSuggestions.length > 1;
									return (
								<select
									className="form-select mt-2"
									size={getSuggestionListSize(zipSuggestions.length, zipHasPrompt)}
									onChange={(e) => {
										const [zip, city] = e.target.value.split("|");

										updateOrder({
											...order,
											partner: {
												...order.partner,
												partner_zip: zip,
												partner_city: city,
											},
										});
										setShowZipSuggestions(false);
									}}
									style={{
										cursor: "pointer",
										overflowY: "auto",
										scrollbarColor: "#adb5bd #f8f9fa",
										scrollbarWidth: "thin",
									}}
								>
									{zipHasPrompt && (
										<option disabled value="">
											Válasszon irányítószámot és várost
										</option>
									)}
									{zipSuggestions.map(({ zip, city }) => (
										<option key={zip + city} value={zip + "|" + city}>
											{zip} - {city}
										</option>
									))}
								</select>
									);
								})()
							)}
						</div>
						<div className="col-lg-3">
							<FloatingLabelInput
								type="text"
								label="Város *"
								id="partner_city"
								name="partner_city"
								value={order.partner.partner_city || ""}
								onChange={handleCityInput}
								autoComplete="off"
								required
								disabled={fieldsLocked}
								onFocus={() => {
									if (Number(order.partner.partner_country_szam) === 2) setShowCitySuggestions(true);
								}}
								onBlur={() => setTimeout(() => setShowCitySuggestions(false), 150)}
							/>
							{Number(order.partner.partner_country_szam) === 2 && showCitySuggestions && citySuggestions.length > 0 && !fieldsLocked && (
								(() => {
									const cityHasPrompt = citySuggestions.length > 1;
									return (
								<select
									className="form-select mt-2"
									size={getSuggestionListSize(citySuggestions.length, cityHasPrompt)}
									onChange={(e) => {
										const [city, zip] = e.target.value.split("|");

										updateOrder({
											...order,
											partner: {
												...order.partner,
												partner_zip: zip,
												partner_city: city,
											},
										});
										setShowCitySuggestions(false);
									}}
									style={{
										cursor: "pointer",
										overflowY: "auto",
										scrollbarColor: "#adb5bd #f8f9fa",
										scrollbarWidth: "thin",
									}}
								>
									{cityHasPrompt && (
										<option disabled value="">
											Válasszon várost és irányítószámot
										</option>
									)}
									{citySuggestions.map(({ city, zip }) => (
										<option key={city + zip} value={city + "|" + zip}>
											{city} - {zip}
										</option>
									))}
								</select>
									);
								})()
							)}
						</div>
						<div className="col-lg-3">
							<FloatingLabelInput type="text" label="Cím (utca, házszám) *" id="partner_address" name="partner_address" value={order.partner.partner_address || ""} onChange={handleInputChange} required disabled={fieldsLocked} />
						</div>
					</div>
					{LakcimError && <div className="invalid-feedback d-block">{LakcimError}</div>}
					<div className="mb-3">
						<FloatingLabelInput type="text" label="Telefonszám *" id="partner_phone" name="partner_phone" value={order.partner.partner_phone || ""} onChange={handleInputChange} error="" required disabled={fieldsLocked} />
					</div>
					<div className="mb-3">
						<FloatingLabelInput type="text" label="Email cím: (Opcionális)" id="partner_email" name="partner_email" value={order.partner.partner_email || ""} onChange={handleInputChange} check_type="email" error="" required disabled={fieldsLocked} />
					</div>
					{order.hmeliorder?.hmeliorder_order_type === 2 && (
						<>
							<div className="mb-3">
								<FloatingLabelInput type="text" label="Születési helye *" id="partner_birthplace" name="partner_birthplace" value={order.partner.partner_birthplace || ""} onChange={handleInputChange} error="" required disabled={fieldsLocked} />
							</div>
							<div className="mb-3">
								<FloatingLabelInput type="date" label="Születés ideje *" id="partner_birthday" name="partner_birthday" value={order.partner.partner_birthday || ""} onChange={handleInputChange} error="" required disabled={fieldsLocked} />
							</div>
						</>
					)}

					<div className="row mt-0">
						<div className="col-12 col-sm-12 col-md-12">
							<span style={{ color: "gray" }}>A csillaggal megjelölt mezők kitöltése kötelező!</span>
						</div>
					</div>

					{!canSubmit && (
						<div className="row mt-3">
							<div className="col-12 col-sm-12 col-md-12">
								<div className="alert alert-danger" role="alert">
									Kérjük, töltse ki a kötelező mezőket a partner adatlapon, hogy folytatni tudja a rendelés rögzítését!
								</div>
							</div>
						</div>
					)}

					<div className="row g-3 mt-4">
						<div className="col-12 col-sm-6 col-md-3">
							<button type="button" className="btn btn-md btn-secondary w-100" onClick={handleBackToPartnerValaszto} disabled={order.ojote?.ojote_jogviszony === "Z" || orderSaveLoading || loading}>
								Partnerkereső
							</button>
						</div>

						<div className="col-12 col-sm-6 col-md-3">
							<button type="button" className="btn btn-md btn-outline-secondary w-100" onClick={handleNewPartner} disabled={order.partner.partner_szam === 1 || order.ojote?.ojote_jogviszony === "Z" || orderSaveLoading || loading}>
								Új partner
							</button>
						</div>

						<div className="col-12 col-sm-6 col-md-3">
							{fieldsLocked && (
								<button className="btn btn-md btn-outline-warning w-100 d-flex align-items-center justify-content-center text-secondary" type="button" onClick={() => handleUnlock()} disabled={orderSaveLoading || loading}>
									<IconLock size={20} className="me-2" />
									Módosítás engedélyezése
								</button>
							)}
						</div>

						<div className="col-12 col-sm-6 col-md-3">
							<button type="button" className="btn btn-md btn-primary w-100" onClick={() => handleNext()} disabled={!canSubmit || orderSaveLoading || loading}>
								Tovább
							</button>
						</div>
					</div>
				</div>
			</div>

			<Modal 
			isOpen={showNewPartnerModal} 
			onClose={() => setShowNewPartnerModal(false)} 
			onConfirm={resetPartnerForm}
			title="Új partner" 
			children="Biztosan szeretne új partnert rögzíteni?" 
			secondaryText="A jelenlegi partner adatai elvesznek!" 
			confirmText="Igen" 
			cancelText="Nem" 
			confirmClass="btn btn-primary" 
			cancelClass="btn btn-danger" 
			showCancel={true} 
			icon={<IconExclamationMark size={70} stroke={2} className="text-warning" />}>
				<h4>Biztosan szeretne új partnert rögzíteni?</h4>
			</Modal>

			<Modal isOpen={showSaveModal.open} onClose={closeModal} title="Mentés" type={showSaveModal.status === "ok" ? "success" : "danger"} confirmText="OK" onConfirm={() => setShowSaveModal({ open: false })} showCancel={false} icon={showSaveModal.status === "ok" ? <IconCheck size={48} stroke={2} className="text-success" /> : <IconAlertCircle size={48} stroke={2} className="text-danger" />}>
				<div dangerouslySetInnerHTML={{ __html: "<h4>" + showSaveModal.message + '</h4><span style="color: gray">Kérem, próbálkozzon ismét!</span>' }} />
			</Modal>
		</TablerLayout>
	);
};

export default Adat;
